/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from "react";
import "./SmallStat.scss";
import { Grid, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { LayoutContext } from "../../context/LayoutContext";

function SmallStat(props) {
  const { item, stats, country, size } = props;
  const { mobileActive } = useContext(LayoutContext);

  const handleToolTipClick = (e) => {
    e.stopPropagation();
  }

  return (
    <Grid item className="small-stat-card" xs={size}>
      <Grid container className="stat-wrapper" spacing={0}>
        <Grid item xs={12} className="stat-title">
          {item.title}
        </Grid>
        <Grid item xs={12} className="stat-value">
          {stats ? stats[item.name][country] : item[country]}{" "}
        </Grid>
        {item.measurement && (
          <Grid item xs={12} className="stat-measurement">
            {item.measurement}
          </Grid>
        )}
        <Grid item xs={12} className="stat-tooltip">
          <Tooltip arrow title={item.tooltip}
            enterTouchDelay={mobileActive ?  40 : 700}
            leaveTouchDelay={mobileActive ?  6000 : 1500}
            onClick={mobileActive ? handleToolTipClick : null}
          >
            <InfoIcon className="info-icon" />
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SmallStat;
